import React from 'react';
import { Link } from 'react-router-dom';

function Sidebar() {
  return (
    <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
      {/* Sidebar - Brand */}
      <Link to="/" className="sidebar-brand d-flex align-items-center justify-content-center">
        <div className="sidebar-brand-icon rotate-n-15">
          <i className="fas fa-laugh-wink" />
        </div>
        <div className="sidebar-brand-text mx-3">
          Baby-Step
        </div>
      </Link>
      {/* Divider */}
      <hr className="sidebar-divider my-0" />
      {/* Nav Item - Dashboard */}
      <li className="nav-item active">
        <Link to="/dashboard" className="nav-link">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Dashboard</span>
        </Link>
      </li>

      <li className="nav-item active">
        <Link to="/customerList" className="nav-link">
          <i className="fas fa-fw fa-folder" />
          <span>Customer List</span>
        </Link>
      </li>
      <li className="nav-item active">
        <Link to="#" className="nav-link collapsed" data-toggle="collapse" data-target="#staffdetails" aria-expanded="true" aria-controls="collapsePages">
          <i className="fas fa-fw fa-folder" />
          <span>Staff Details</span>
        </Link>
        <div id="staffdetails" className="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <Link to="/addstaff" className="collapse-item">Add Staff</Link>
            <Link to="/stafflist" className="collapse-item">Staff List</Link>

          </div>
        </div>
      </li>
      <li className="nav-item active">
        <Link to="#" className="nav-link collapsed" data-toggle="collapse" data-target="#ratetemplate" aria-expanded="true" aria-controls="collapsePages">
          <i className="fas fa-fw fa-folder" />
          <span>Rate Template</span>
        </Link>
        <div id="ratetemplate" className="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <Link to="/ratetemplete" className="collapse-item">Create Rate Template</Link>
            <Link to="/ratetempletelist" className="collapse-item">Rate Template List</Link>

          </div>
        </div>
      </li>
      <li className="nav-item active">
        <Link to="/orderlist" className="nav-link">
          <i className="fas fa-fw fa-folder" />
          <span>Order List</span>
        </Link>
      </li>

      {/* Divider */}
      {/* <hr className="sidebar-divider" /> */}
      {/* Heading */}
      {/* <div className="sidebar-heading">Addons</div> */}
      {/* Nav Item - Pages Collapse Menu */}
      {/* <li className="nav-item">
        <Link to="#" className="nav-link collapsed" data-toggle="collapse" data-target="#collapsePages" aria-expanded="true" aria-controls="collapsePages">
          <i className="fas fa-fw fa-folder" />
          <span>Pages</span>
        </Link>
        <div id="collapsePages" className="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
          <div className="bg-white py-2 collapse-inner rounded">
            <h6 className="collapse-header">Login Screens:</h6>
            <Link to="/ratetemplete" className="collapse-item">Create Rate Template</Link>
            <Link to="/ratetempletelist" className="collapse-item">Rate Template List</Link>
            <Link to="/cancelledList" className="collapse-item">Cancelled List</Link>
            <Link to="/customerList" className="collapse-item">Customer List</Link>
            <Link to="/enquiryList" className="collapse-item">Enquiry List</Link>
            <Link to="/massagePricing" className="collapse-item">Massage Pricing</Link>
            <Link to="/massiveRequestList" className="collapse-item">Massive Request List</Link>
            <Link to="/ongoingRequestList" className="collapse-item">On-going Request List</Link>
            <Link to="/totalRequestList" className="collapse-item">Total Request List</Link>
          </div>
        </div>
      </li> */}
      {/* Nav Item - Charts */}
      {/* <li className="nav-item">
        <Link to="/charts.html" className="nav-link">
          <i className="fas fa-fw fa-chart-area" />
          <span>Charts</span>
        </Link>
      </li> */}
      {/* Nav Item - Tables */}
      {/* Divider */}
      <hr className="sidebar-divider d-none d-md-block" />
      {/* Sidebar Toggler (Sidebar) */}


    </ul>
  );
}

export default Sidebar;
